import { sendIpcLog } from './ipcRendererEvents';

export const defaultErrorHandler = (error, info, props) => {
  console.error('defaultErrorHandler handled', error, info, props);
  sendIpcLog('error', error, info, props);
};
